export const pronouns = [
  {
    id: 'personalpronomen',
    category: 'pronomen',
    level: 'A1',
    title: 'Personalpronomen (Përemrat Vetorë)',
    detailedContent: `
      <section>
        <p><b>Përemrat vetorë</b> përdoren për të zëvendësuar emrat e njerëzve, kafshëve, koncepteve apo sendeve, në mënyrë që të mos i përsërisim ato vazhdimisht në fjali. Secili përemër lakohet në 4 rastet gramatikore (Nominativ, Akkusativ, Dativ, Genitiv).</p>

        <h3>1. Roli i tyre në fjali</h3>
        <ul>
          <li><b>Nominativ (Kush?):</b> <i><b>Ich</b> liebe dich.</i> (Unë -> Kryefjala).</li>
          <li><b>Akkusativ (Kë?):</b> <i>Ich liebe <b>dich</b>.</i> (Ty -> Kundrinori i drejtë).</li>
          <li><b>Dativ (Kujt?):</b> <i>Ich helfe <b>ihm</b>.</i> (Atij -> Kundrinori i zhdrejtë).</li>
          <li><b>Genitiv (I/E kujt?):</b> Shumë i rrallë sot, kryesisht zëvendësohet me përemrat pronorë (shih më poshtë). P.sh. "Wir gedenken <b>seiner</b>" (Ne e kujtojmë atë).</li>
        </ul>

        <h3>2. Përdorimi i "Sie" (Formale) vs "sie" (shumës) vs "sie" (ajo)</h3>
        <p>Kujdes! Në gjermanisht fjala "sie" përdoret për 3 gjëra thelbësisht të ndryshme:</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <ol>
            <li><b>sie (ajo):</b> Përcakton një grua ose një emër "die". Folja merr <b>-t</b>. <i>(sie singt)</i></li>
            <li><b>sie (ata/ato):</b> Përcakton shumësin e njerëzve/sendeve. Folja merr <b>-en</b>. <i>(sie singen)</i></li>
            <li><b>Sie (Ju - Formale):</b> Shkruhet GJITHMONË me shkronjë të madhe. Folja merr <b>-en</b>. Përdoret për respekt ndaj të panjohurve. <i>(Singen Sie?)</i></li>
          </ol>
        </div>
      </section>
    `,
    tables: [
      {
        label: 'Tabela: Lakimi i Përemrave Vetorë',
        headers: ['Veta / Gjinia', 'Nominativ (Kryefjalë)', 'Akkusativ', 'Dativ'],
        rows: [
          ['es (1 Nj)', 'ich (unë)', 'mich (mua)', 'mir (më / mua)'],
          ['du (2 Nj)', 'du (ti)', 'dich (ty)', 'dir (të / ty)'],
          ['er (3 Nj. Mashk)', 'er (ai / ai send)', 'ihn (atë)', 'ihm (atij)'],
          ['sie (3 Nj. Fem)', 'sie (ajo / ajo send)', 'sie (atë)', 'ihr (asaj)'],
          ['es (3 Nj. Asnj)', 'es (ai / ajo asnjëanës)', 'es (atë)', 'ihm (atij / asaj)'],
          ['wir (1 Sh)', 'wir (ne)', 'uns (ne)', 'uns (neve)'],
          ['ihr (2 Sh)', 'ihr (ju)', 'euch (ju)', 'euch (juve)'],
          ['sie (3 Sh)', 'sie (ata / ato)', 'sie (ata / ato)', 'ihnen (atyre)'],
          ['Sie (Formale)', 'Sie (Ju)', 'Sie (Ju)', 'Ihnen (Juve)']
        ]
      }
    ],
    examples: [
      { ger: 'Gib mir bitte das Buch.', alb: 'Ma jep MUA të lutem atë libër. (geben kërkon Dativ -> mir)' },
      { ger: 'Ich sehe ihn jeden Tag.', alb: 'Unë e shoh ATË (mashkullore) çdo ditë. (sehen kërkon Akkusativ -> ihn)' }
    ],
    exercises: [
      { question: 'Si themi "Ne e ndihmojmë atë (gruan)"?', options: ['Wir helfen sie', 'Wir helfen ihr', 'Wir helfen ihn'], correct: 1, explanation: 'Folja helfen kërkon DATIV. Dativi i "sie (ajo)" është "ihr".' }
    ]
  },
  {
    id: 'possessivpronomen',
    category: 'pronomen',
    level: 'A2',
    title: 'Possessivpronomen (Përemrat Pronorë)',
    detailedContent: `
      <section>
        <p><b>Përemrat pronorë</b> tregojnë pronësinë ose përkatësinë. Ata i përgjigjen pyetjes "I kujt?" (Wessen?). Pronorët thelbësorë NËNKSHTROHEN të njëjtave rregulla si lakimi i "ein / eine" (Nyja e Pashquar) ! Pra kjo do të thotë që ata marrin fundoret përkatëse varësisht rastit.</p>

        <h3>1. Cilët janë pronorët bazë (Në Nominativ)?</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <ul>
            <li>ich -> <b>mein</b> (i imi)</li>
            <li>du -> <b>dein</b> (i yti)</li>
            <li>er -> <b>sein</b> (i tij / e tij)</li>
            <li>sie (ajo) -> <b>ihr</b> (i saj / e saj)</li>
            <li>es -> <b>sein</b> (i tij / e tij)</li>
            <li>wir -> <b>unser</b> (i yni)</li>
            <li>ihr -> <b>euer</b> (i juaji)</li>
            <li>sie (ata/ato) -> <b>ihr</b> (i tyre)</li>
            <li>Sie (Formale) -> <b>Ihr</b> (i Juaji)</li>
          </ul>
        </div>
        
        <h3>2. Si bëhet Deklinimi (Lakimi) i Pronorëve?</h3>
        <p>Për t'i dhënë MBARESAT, shikoni gjininë dhe numrin e EMERIT QË PO ZOTËROHET.</p>
        <p>P.sh: <i>Ich sehe main<b>en</b> Vater.</i> (sepse Vater është Akkusativ Mashkullor).</p>
      </section>
    `,
    tables: [
      {
        label: 'Tabela: MBARESAT (Treguar përmes "mein")',
        headers: ['Kasus', 'Maskulin (der)', 'Feminin (die)', 'Neutral (das)', 'Plural (die)'],
        rows: [
          ['Nominativ', 'mein_ Vater', 'mein<b>e</b> Mutter', 'mein_ Kind', 'mein<b>e</b> Eltern'],
          ['Akkusativ', 'mein<b>en</b> Vater', 'mein<b>e</b> Mutter', 'mein_ Kind', 'mein<b>e</b> Eltern'],
          ['Dativ', 'mein<b>em</b> Vater', 'mein<b>er</b> Mutter', 'mein<b>em</b> Kind', 'mein<b>en</b> Eltern'],
          ['Genitiv', 'mein<b>es</b> Vaters', 'mein<b>er</b> Mutter', 'mein<b>es</b> Kindes', 'mein<b>er</b> Eltern']
        ]
      }
    ],
    examples: [
      { ger: 'Das ist mein Auto.', alb: 'Kjo është makina ime. (mein_ Auto sepse Auto është Asnjanëse / Neutrum).' },
      { ger: 'Er fährt mit seinem Auto.', alb: 'Ai nget MAKINËN E TIJ. ("mit" + dativ neutral = seinem).' },
      { ger: 'Wir fragen unsere Lehrerin.', alb: 'Ne pyesim MËSUESEN TONË. (Akkusativ Feminin -> unser + e).' }
    ],
    exercises: [
      { question: 'Zgjidhni formën e saktë: Ich schenke (atij) _____ Mutter eine Blume.', options: ['ihre', 'seiner', 'ihnen'], correct: 1, explanation: 'atij = er -> pronori bëhet sein-. "schenke" merr Dativ (Cujt i dhuron?). Mutter është die. Dativ i "die" është "der". Pra "sein" + "er" = seiner Mutter.' }
    ]
  },
  {
    id: 'reflexivpronomen',
    category: 'pronomen',
    level: 'A2',
    title: 'Reflexivpronomen (Përemrat Vetvetorë)',
    detailedContent: `
      <section>
        <p><b>Përemrat vetvetorë</b> kthejnë veprimin përsëri tek kryefjala (Subjekti). Ne i përdorim ato kur objekti dhe subjekti janë IDENTIKË ! P.sh "Unë THEKSHEM (vetveten) po lahem".</p>
        
        <h3>1. Përdorimi me foljet refleksive (sich verbs)</h3>
        <p>Folje si "sich waschen (të lahesh)", "sich freuen (të gëzohesh)", "sich ärgern (të nxehesh)".</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Mbaje mend gjenialisht:</strong> Në vetën e 3-të (njëjës e shumës) the për "Sie" formale, vetvetori është GJITHMONË <b>sich</b>.
        </div>

        <h3>2. Dativ VS Akkusativ në Reflexiv</h3>
        <p>A. <b>Akkusativ (Gati gjithmonë):</b> Kur po theksoni gjendjen e gjitha. <i>Ich ziehe <b>mich</b> an. (Unë po (më) mbath/vish).</i></p>
        <p>B. <b>Dativ (Për pjesë të trupit / objekte thelbësore të vetja):</b> Kur specifikoni "ÇFARË" po i lani vetes (rrobat, duart, dhëmbët). <i>Ich wasche <b>mir</b> die Hände. (Po i laj VETES duart - the Hände marrin Akkusativin e drejperdejt, pra un mar dativ as a person).</i></p>
      </section>
    `,
    tables: [
      {
        label: 'Tabela: Reflexivpronomen (Akkusativ dhe Dativ)',
        headers: ['Veta', 'Akkusativ (Kë?)', 'Dativ (Kujt?)'],
        rows: [
          ['ich', 'mich', 'mir'],
          ['du', 'dich', 'dir'],
          ['er / sie / es', '<b>sich</b>', '<b>sich</b>'],
          ['wir', 'uns', 'uns'],
          ['ihr', 'euch', 'euch'],
          ['sie / Sie', '<b>sich</b>', '<b>sich</b>']
        ]
      }
    ],
    examples: [
      { ger: 'Ich kämme mich.', alb: 'Unë po (më) kreh(em). -> Akkusativ' },
      { ger: 'Ich kämme mir die Haare.', alb: 'Unë po IA KREH VETES -> Flokët. -> Dativ se flokët jan objekti qe perfshin krehja.' }
    ],
    exercises: [
      { question: 'Plotësoni: Wir trafen ___ am Bahnhof. (U takuam në stacion)', options: ['uns', 'wir', 'sich'], correct: 0, explanation: '"uns" është përemri vetvetor i vetës së 1-rë Shumës.' }
    ]
  },
  {
    id: 'demonstrativpronomen',
    category: 'pronomen',
    level: 'B1',
    title: 'Demonstrativpronomen (Përemrat Dëftorë)',
    detailedContent: `
      <section>
        <p>Përdoren për të ZGJEDHUR, VEAÇUAR dhe TREGUAR ME GISHIT diçka shumë të theksuar midis një grupi.</p>
        <p>Kryesoret janë: <b>dieser</b> (ky/kjo - për gjëra afër) dhe <b>jener</b> (ai/ajo - për gjëra larg, i harruar e letrar).</p>
        
        <h3>Si lakohen këto?</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Ata marrin 1-për-1 treguesin e fundit të nyjeve "der/die/das" !</strong>
        </div>
        <ul>
          <li>d<b>er</b> Mann -> dies<b>er</b> Mann (ky burrw)</li>
          <li>d<b>as</b> Auto -> dies<b>es</b> Auto (kjo makinw)</li>
          <li>d<b>en</b> Mann (Akk) -> dies<b>en</b> Mann (kwtw burrw)</li>
          <li>d<b>em</b> Kind (Dativ) -> mit dies<b>em</b> Kind</li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'relativpronomen',
    category: 'pronomen',
    level: 'B1',
    title: 'Relativpronomen (Përemrat Lidhës / Fjalitë Relative)',
    detailedContent: `
      <section>
        <p>Këto nuk bëjnë pyetje ('Cili?'), por BASHKOJNË dy fjali duke përshkruar thellë emrin e fjalisë së parë. (P.sh: Burri, <b>I CILI</b>...)</p>
        <p>Përemrat lidhës ngjajnë thuajse EKZAKT si nyjet e shquara (der, die, das, die), me dallimin e thatë në Dativ Shumës dhe në thelbin e Genitivit !</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli i fjalisë relative:</strong> Përemri Lidhës merr GJININË dhe NUMRIN nga emri që përshkruan mbrapsht, POR e merr RASTIN nga FUNKSIONI i tija thelbësor NË FJALINË E RE! Folja në fjalinë relative e re ZBYTHET PLOTËSISHT NË FUND!
        </div>
      </section>
    `,
    tables: [
      {
        label: 'Relativpronomen (Ndryshimet e VETME nga Nyjet jan me të trashë)',
        headers: ['Kasus', 'Maskulin', 'Feminin', 'Neutral', 'Plural'],
        rows: [
          ['Nominativ (i cili)', 'der', 'die', 'das', 'die'],
          ['Akkusativ (të cilin)', 'den', 'die', 'das', 'die'],
          ['Dativ (të cilit)', 'dem', 'der', 'dem', '<b>denen</b>'],
          ['Genitiv (pronon i cilit)', '<b>dessen</b>', '<b>deren</b>', '<b>dessen</b>', '<b>deren</b>']
        ]
      }
    ],
    examples: [
      { ger: 'Das ist der Mann, der in Berlin wohnt.', alb: 'Ky është burri, I CILI banon në Berlin. (der Mann = der. Ne fjalin e dyt asht subjekti ndaj don -> der. Folja wohnt rri n Fund!)' },
      { ger: 'Das ist der Mann, den ich liebe.', alb: 'Ky është burri, TË CILIN unë e dua. (Akkusativ -> den. Sepse une e dua TE CILIN)' },
      { ger: 'Die Leute, mit denen ich arbeite, sind nett.', alb: 'Njërezit, ME TË CILËT unë punoj, janë të mirë. (mit kërkon Dativ -> shumësi i Dativ relativ është DENEN).' }
    ],
    exercises: [
      { question: 'Zgjidh fijen thelbësore lidhëse: "Die Frau, ____ ich geholfen habe, heißt Maria."', options: ['der', 'die', 'denen'], correct: 0, explanation: 'Folja helfen do Dativ. Gruaja = die. Dativi thelb i "die" asht "der". Dhe thelbi "der" funksionin si relativ ne dativ!' }
    ]
  },
  {
    id: 'indefinitpronomen',
    category: 'pronomen',
    level: 'B1',
    title: 'Indefinitpronomen (Përemrat e Papërcaktuar)',
    detailedContent: `
      <section>
        <p>I referohen thelbeve personash apo sendeve TË CLIPOSHTJEVE, pa ia specifikuar emrin absolut.</p>
        
        <h3>1. Për Njerëzit (Jemand / Niemand)</h3>
        <ul>
          <li><b>jemand</b> (dikush). -> Akkusativ: jemand<b>en</b>. Dativ: jemand<b>em</b>.</li>
          <li><b>niemand</b> (askush). -> Akkusativ: niemand<b>en</b>. Dativ: niemand<b>em</b>.</li>
          <li><b>alle</b> (të gjithë - numri shumës gjithmon). <i>Alle sind gekommen.</i></li>
          <li><b>jeder / jede / jedes</b> (secili / çdo ...). Merr treguesin thelb e gjdo gjinisë së emrit nga pas!</li>
        </ul>

        <h3>2. Për Sendet (Etwas / Nichts)</h3>
        <ul>
          <li><b>etwas</b> (diçka). As NUK LAKOHET kurr. Mban t'njejten form kudo. <i>Ich möchte etwas trinken.</i></li>
          <li><b>nichts</b> (asgjë). Gjithashtu ngrijt i pandryshuar. <i>Ich habe nichts gesehen.</i></li>
          <li><b>alles</b> (gjithçka inanime/thelb thelbsor i përgjiths ). <i>Alles ist gut.</i></li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'interrogativpronomen',
    category: 'pronomen',
    level: 'A1',
    title: 'Interrogativpronomen (Përemrat Pyetës - W Fragen)',
    detailedContent: `
      <section>
        <p>Shërbejnë thellësisht për të formuar pyetje direkte dhe indirekte.</p>
        <ul>
          <li><b>wer?</b> (Kush?) - Kërkon Subjektin / Nominativ. <i>Wer ist das?</i></li>
          <li><b>wen?</b> (Kë?) - Kërkon Akkusativin. <i>Wen liebst du?</i></li>
          <li><b>wem?</b> (Kujt?) - Kërkon Dativin. <i>Wem gibst du das Buch?</i></li>
          <li><b>wessen?</b> (I/E kujt?) - Kërkon Genitivin. <i>Wessen Auto ist das?</i></li>
          <li><b>was?</b> (Çfarë?) - Për sende abstrakte.</li>
          <li><b>welcher, welche, welches?</b> (Cili?) - Kërkon formim e vendimit mes zgjedhejve. Këta dekliniohen ekzaktësishjt si Definite Artikel ! -> <i>Welches Auto kaufst du?</i> <i>Nach welchem Mann suchst du?</i></li>
        </ul>
      </section>
    `,
    exercises: []
  },

  // Pronomen speciale
  {
    id: 'pron-man',
    category: 'pronomen',
    level: 'A2',
    title: 'Përemri Thelbësor Përgjithsues "man" (Njeriu / Njerëzit)',
    detailedContent: `
      <section>
        <p>Fjala <b>"man"</b> përdoret vazhdimisht në Gjermani për të theksuar thënie të përgjithsëshme thelbësore shoqërore !. NUK Luan formen e Gjinisë MASKULIN "der Mann", për tu bëh mbuler me të - POR Përkthehes në shqip si "Njerëzit, Ti, Njeriu në Përgjlithësi".</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli absolut:</strong> Edhe pse thellë po thekson NJP numër shoqërie në masë, gramatikisht zgjedhon foljet në VETA e 3-TË NJĘJS (er/sie/es).
        </div>
        <ul>
          <li><i>Hier darf <b>man</b> nicht rauchen.</i> (Këtu nuk pini/pihet / smundesh me pi Duhan).</li>
          <li><i>Wie spricht <b>man</b> das aus?</i> (Si shqiptoht kjo gj? Si i thon njerëzit këti?)</li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'pron-es',
    category: 'pronomen',
    level: 'A2',
    title: 'Përemri i Zbrazët / Thelbësor "es"',
    detailedContent: `
      <section>
        <p>Rroli magjik dhe thelb i "Es" përveç rastëve normale kur flet për një fshi (das Kind - es), përdoret shpesh si 'Dummy Pronoun (Përemër Pazbrazët)' Për subjekte pa kuptim nenzeshmeve (Moti / Koha / Rrethantsis).</p>
        <ul>
          <li><b>Sajim Moti:</b> <i>Es regnet.</i> (Po bie shi). <i>Es ist kalt.</i> (Ftohtë.).</li>
          <li><b>Koha orareshe:</b> <i>Es ist 3 Uhr.</i> <i>Es ist spät.</i></li>
          <li><b>Thelbet pasiv:</b> <i>Es gibt viele Leute hier.</i> (Thelbi "Jepen/ Ndodhen / Ka").</li>
        </ul>
      </section>
    `,
    exercises: []
  }
];
